<template>
  <BRow class="tickets-list">
    <BCol
      v-for="(ticket, idx) in props.tickets"
      :key="ticket.id"
      class="ticket-col"
      :md="ticket.big_block == true ? 8 : 4"
    >
      <div
        class="ticket-card"
        :class="{ 'ticket-card--wide': idx === 0 }"
        :style="{ backgroundImage: `url('${ticket.block_background}')` }"
      >
        <div class="ticket-card__content">
          <div class="ticket-card__top">
            <h2 class="ticket-card__title">{{ ticket.title }}</h2>
            <p class="ticket-card__note">{{ ticket.description }}</p>
          </div>
          <div class="ticket-card__footer">
            <span class="ticket-card__price" v-if="ticket.price">{{ formatPrice(ticket.price) }}</span>
            <b-button @click.prevent="openTicketsWidget({ id: ticket.afisharu_id, widgetKey: ticket.afisharu_widgetkey, route: ticket.afisharu_route, creationType: ticket.afisharu_creation_type, cityId: ticket.afisharu_city_id })" class="ticket-card__button">
              {{ t('Buy ticket') }}
            </b-button>
          </div>
        </div>
      </div>
    </BCol>
  </BRow>
</template>

<script setup lang="ts">
const props = defineProps<{
  tickets: any[]
}>()

// @ts-ignore - useI18n is available globally in Nuxt
const { t } = useI18n()

function formatPrice(price: number) {
  if (price === 0) return '0 руб.';
  if (price === null) return null;
  return price.toLocaleString('ru-RU') + ' руб.';
}

const openTicketsWidget = async ({ id, widgetKey, route, creationType, cityId }: { id: string | number, widgetKey: string, route: string, creationType: string, cityId: string }) => {
    // console.log('openTicketsWidget', id, widgetKey)
    // Check if we are on the client side
    if (process.client) {
      const module = await import('afisha-widget-manager')
      const WidgetManager = module.WidgetManger || (module as any).default
      let manager = new WidgetManager(widgetKey)
      manager.appendWidget({
        widgetKey: widgetKey,
        route: route,
        creationType: creationType,
        embedType: 'modal',
        cityId: cityId,
        creationId: id ? String(id) : undefined,
      })
    }
}

</script>

<style lang="scss" scoped>
// .tickets-list {
//   --bs-gutter-x: 0;
//   --bs-gutter-y: 1rem;
// }
.ticket-col {
  // padding-left: 8px !important;
  // padding-right: 8px !important;
  margin-bottom: 1rem;
}
.ticket-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 320px;
  position: relative;
  background-size: cover;
  background-position: center;
  border-radius: 20px;
  color: #fff;
  min-width: 0;
  padding: 32px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.08);
  transition: box-shadow 0.2s;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    pointer-events: none;
    background: linear-gradient(to top, rgba(0,0,0,0.32) 0%, rgba(0,0,0,0.12) 40%, rgba(0,0,0,0) 100%);
    z-index: 1;
  }
}
.ticket-card__content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  min-height: 100%;
  position: relative;
  z-index: 2;
}
.ticket-card--wide .ticket-card__content {
  max-width: 700px;
  margin-left: 0;
  margin-right: auto;
  width: 100%;
  flex-grow: 1;
  height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.ticket-card__top {
  margin-bottom: auto;
}
.ticket-card__title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 16px;
  color: #fff;
}
.ticket-card__note {
  font-size: 1.1rem;
  margin-bottom: 0;
  margin-top: 0;
  color: #fff;
}
.ticket-card__footer {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 32px;
}
.ticket-card__price {
  font-size: 1.2rem;
  font-weight: 600;
  color: #fff;
}
.ticket-card__button {
  background: #fff !important;
  color: #111 !important;
  font-weight: 700 !important;
  border-radius: 999px !important;
  padding: 8px 32px !important;
  border: none !important;
  box-shadow: none !important;
  font-size: 1.1rem !important;
  letter-spacing: 0;
  transition: box-shadow 0.2s, background 0.2s;
  min-width: 120px;
  text-align: center;
  &:hover, &:focus {
    background: #f5f5f5 !important;
    color: #111 !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.10);
  }
}
</style>

<i18n lang="json">
{
  "ru": {
    "Buy ticket": "Купить билет"
  }
}
</i18n>